module.exports = __webpack_public_path__ + "static/media/open-ai.97631a29.png";